// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__mgqnO","spinner-color-green":"Spinner_spinner-color-green__QyiNq"};